import React from 'react';

const FilterTextInput = ({ title, value, onChange }) => (
  <div className="column">
    <div className="field">
      <div className="label">
        <label htmlFor="" className="label">
          {title}
        </label>
      </div>
      <div className="field-body">
        <div className="field">
          <p className="control is-expanded">
            <input
              className="checkbox"
              type="checkbox"
              placeholder=""
              onChange={onChange}
              value={value}
            />
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default FilterTextInput;
